import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_DELETE_COMPANY_RULE } from 'store';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import { api } from 'services';
import MasterPage from 'components/MasterPage';
import Listing from 'components/Listing';
import { DashboardOutlined } from '@material-ui/icons';
import Can from 'components/Can';

const CompanyRulesList = ({ deleteCompanyRule }) => {
  const defaultFilters = { search: '', per_page: 10, page: 1 };
  const [data, setData] = useState({ data: [] });

  const [filters, setFilters] = useState([]);

  let dialog;

  useEffect(() => {
    api.get('company-rules').then(({ data }) => setData(data));
  }, []);

  useEffect(() => {
    api
      .get('company-rules', { params: { ...filters } })
      .then(({ data }) => setData(data));
  }, [filters]);

  const { t } = useTranslation();

  const effectDeleteCompanyRule = id => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger'
    });

    dialog.show({
      title: t('title:company rule delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => deleteCompanyRule(id))
      ],
      bgSize: 'small'
    });
  };

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Dialog
          ref={component => {
            dialog = component;
          }}
        />
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:company rules list')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row className="mb-5">
              <Col>
                <Can do="createCompanyRules" on="App">
                  <Button
                    size="sm"
                    className="login-btn mr-1"
                    variant="primary-login"
                    as={Link}
                    to="/company-rules/create"
                  >
                    <i className="fas fa-plus"></i> {t('label:add new')}
                  </Button>
                </Can>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Listing
                  fields={[
                    { name: 'company name', key: 'name', type: 'string' },
                    { name: 'fantasy name', key: 'alias', type: 'string' },
                    {
                      name: 'registered number',
                      key: 'document',
                      type: 'string'
                    },
                    {
                      name: 'period',
                      type: 'custom',
                      value: (flatten, data) => {
                        switch (data.rules.length) {
                          case 1:
                            return t('label:annual');
                          case 2:
                            return t('label:semiannual');
                          case 4:
                            return t('label:quarterly');
                          default:
                            return '--';
                        }
                      }
                    },
                    { name: 'period start', key: 'period_start', type: 'date' }
                  ]}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  data={data}
                  handleFilterChange={handleFilterChange}
                  actions={[
                    (company, k) => (
                      <Can do="editCompanyRules" on="App">
                        <Button
                          size="sm"
                          key={k}
                          as={Link}
                          to={`/company-rules/edit/${company.id}/${company.rules[0].fiscal_year}`}
                          variant="light"
                          alt={t('title:edit')}
                          title={t('title:edit')}
                        >
                          <i className="fas fa-pen"></i>
                        </Button>
                      </Can>
                    ),
                    (company, k) => (
                      <Can do="deleteCompanyRules" on="App">
                        <Button
                          size="sm"
                          key={k}
                          className="ml-1"
                          variant="danger"
                          onClick={() => effectDeleteCompanyRule(company.id)}
                          alt={t('title:delete')}
                          title={t('title:delete')}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      </Can>
                    )
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  deleteCompanyRule: id =>
    dispatch({ type: ASYNC_DELETE_COMPANY_RULE, payload: { id } })
});

const reduxConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyRulesList);

export default MasterPage(reduxConnect);
